module.exports = __webpack_public_path__ + "img/logo5.19018ae4.jpg";